import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'dotenv/config'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import qs from 'querystring';


function setup() {
    // Check for redirect before React app initialization
    try {
        const params = qs.parse(window.location.search.substring(1));
        const redirectUrl = process.env.REACT_APP_REDIRECT_URL;
        const redirectCompanyKeys = process.env.REACT_APP_REDIRECT_COMPANY_KEYS;
        const companyAPIKey = process.env.REACT_APP_COMPANY_API_KEY || params['companyApiKey'];

        if (redirectUrl && redirectCompanyKeys && companyAPIKey) {
            const companyKeysArray = redirectCompanyKeys.split(',').map(key => key.trim().toLowerCase());
            const allAllowed = redirectCompanyKeys === '*';

            if (allAllowed || companyKeysArray.some(key => companyAPIKey.toLowerCase().endsWith(key))) {
                const urlWithParams = `${redirectUrl}${window.location.search}`;
                window.location.href = urlWithParams;
                return; // Only return if redirecting
            }
        }
    } catch (error) {
        // If redirect fails, continue loading React app
        console.warn('Redirect check failed:', error);
    }

    ReactDOM.render(<App baseURL={process.env.REACT_APP_BASE_URL} wsBaseURL={process.env.REACT_APP_WEBSOCKET_URL} companyAPIKey={process.env.REACT_APP_COMPANY_API_KEY} user={process.env.REACT_APP_USERNAME} password={process.env.REACT_APP_API_KEY} />, document.getElementById('root_appybee_widget'));

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
}

setup();